import { forwardRef, useCallback, KeyboardEvent } from "react";

import { SxProps, Theme } from "@mui/material/styles";

import { DashboardIcon } from "../Icon";
import { DashboardTextField } from "../TextField/DashboardTextField";

import { Close } from "@/icons/filled";
import { Search } from "@/icons/outlined";

interface SearchFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export const DashboardSearchField = forwardRef<HTMLInputElement, SearchFieldProps>(
  ({ value, onChange, placeholder, disabled, sx }, ref) => {
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange?.(e.target.value);
    };

    const handleOnClear = useCallback(() => {
      onChange?.("");
    }, [onChange]);

    const handleOnKeyDown = useCallback(
      (event: KeyboardEvent) => {
        if (event.key === "Escape") {
          handleOnClear();
        }
      },
      [handleOnClear]
    );

    return (
      <DashboardTextField
        ref={ref}
        value={value}
        onChange={handleOnChange}
        placeholder={placeholder}
        disabled={disabled}
        startAdornment={
          <DashboardIcon vibe="text-form-quiet">
            <Search />
          </DashboardIcon>
        }
        endAdornment={
          value &&
          !disabled && (
            <DashboardIcon onClick={handleOnClear} vibe="text-form-quiet">
              <Close />
            </DashboardIcon>
          )
        }
        onKeyDown={handleOnKeyDown}
        sx={sx}
      />
    );
  }
);

DashboardSearchField.displayName = "DashboardSearchField";
